import React from 'react'
import classes from './AboutUs.module.scss'
import {Anchor, Box, Container, Flex, rem, Text, Title} from "@mantine/core";
import {TitleDecor} from "@/components/TitleDecor/TitleDecor";

export const AboutUs = () => {

    return (
        <>
            <section id='about' className={classes.sectionAbout}>
                <Container h={'100%'}>
                    <TitleDecor mb="3rem">About <span>Us</span></TitleDecor>
                    <Flex align="center" justify="stretch">
                        <Box ta={'center'}
                             w="100%"
                             maw={{lg: rem(960)}}
                             mx="auto"
                             px={{base: 'md', md: 'xl'}}>

                            <Text>We all joined NapsGear with one common goal in mind – self improvement. Getting
                                started on
                                the right path is the most difficult part; getting the right info is often the first
                                place
                                we look: bodybuilding magazines, forums, and close friends to name a few.</Text>
                            <Text>
                                <Anchor href="https://www.napsgear.org/ama.php" title="NapsGear’s IFBB Pro AMA">
                                    NapsGear’s IFBB Pro AMA</Anchor> (ask me anything) offers our customers the
                                opportunity
                                to ask the hard
                                questions and actually receive a credentialed and qualified answer. Who better to
                                get your
                                bodybuilding and fitness advice from than an IFBB Pro?! NapsGear is proud to
                                introduce our
                                IFBB Pro leaders: Evan Centopani, Chris Tuttle, Jordan Peters, Milos Sarcev, with
                                more on
                                the way!</Text>
                            <Text>Each week our IFBB Pros will answer your questions in written form
                                as well as
                                educational
                                videos! Need nutrition tips? Want help dialing in your routine? Curious what book an
                                IFBB
                                Pro is reading? Submit your questions now and get an answer from an IFBB Pro!</Text>
                            <Box

                                mt="3rem">
                                <Title order={2}>
                                    <Anchor
                                        fz="inherit"
                                        fw="inherit"
                                        rel="noopener"
                                        href="https://www.napsgear.org/ama.php">
                                        ASK THEM ANYTHING!</Anchor>
                                </Title>
                            </Box>

                        </Box>
                    </Flex>
                </Container>
            </section>
        </>
    )
}


